export function getAsgIvtAdvancedFilter(data) {
    return {
        type: "GET_ASSIGN_INVENTORY_ADVANCED_FILTER_REDUCER",
        payload: {
            advancedFilter: data,
        }
    };
};